import React, { act, useEffect, useState } from 'react';
import { Card, Col, Row, Input, Avatar, Button, Form, Modal, Typography, Progress, Tabs, Space, Upload, Checkbox, message, Popconfirm } from 'antd';
import UserService from '../../services/UserService';
import { formatDate, formatDateString, hasRole, openNotification, handlePhonePaste } from '../../utils';
import './profile.scss'
import UserAttemps from './UserAttemps';
import Contracts from '../../components/Proile/Contracts';
import ImageUpload from '../../components/Uploads/ImageUpload';
import { Mail02Icon } from 'hugeicons-react';
import { SmartPhone01Icon } from 'hugeicons-react';
import PhoneNumberDisplay from '../../components/PhoneNumberDisplay';
import DocumentsTab from './DocumentsTab';

const { Title, Text, Paragraph } = Typography;
const { TabPane } = Tabs;

interface ProfileData {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    address: string;
    identityNumber: string;
    iban: string;
    password?: string;
    profilePhoto?: string;
    createdAt: string;
    individual: boolean;
    partner: boolean;
    isPhoneVerified: boolean;
    [key: string]: any;

}

const modalContents: { [key: string]: JSX.Element } = {
    privacyPolicy: (
        <Typography>
            <Paragraph>
                Gizlilik Politikası metni burada yer alacak. Bu metin, kullanıcıların gizlilik hakları ve kişisel verilerin nasıl korunduğu hakkında bilgi içerir.
            </Paragraph>
        </Typography>
    ),
    terms: (
        <Typography>
            <Paragraph>
                İş Ortağı Sözleşmesi metni burada yer alacak. Bu metin, kullanıcıların siteyi kullanırken uymaları gereken kurallar ve şartlar hakkında bilgi içerir.
            </Paragraph>
        </Typography>
    ),
    clarification: (
        <Typography>
            <Title level={4}>Kişisel Verilerin Korunması Kanunu (KVKK) Aydınlatma Metni</Title>
            <Paragraph>
                <strong>1. Veri Sorumlusu ve Temsilcisi</strong><br />
                Bu aydınlatma metni, Kontrol X İş Güvenliği Hizmetleri tarafından, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca, veri sorumlusu sıfatıyla, iş güvenliği uzmanlarının kişisel verilerinin işlenmesine ilişkin olarak bilgilendirme amacıyla hazırlanmıştır.
            </Paragraph>
            <Paragraph>
                <strong>2. Kişisel Verilerin İşlenme Amacı</strong><br />
                Toplanan kişisel veriler, iş güvenliği uzmanlarının ihtiyaç duyduğu ekipmanlar için teklif alabilmesi amacıyla işlenecektir. Bu kapsamda kişisel veriler şu amaçlarla işlenmektedir:
                <ul>
                    <li>Teklif sürecinin yürütülmesi</li>
                    <li>İletişim süreçlerinin yönetilmesi</li>
                    <li>Müşteri memnuniyetinin sağlanması ve artırılması</li>
                    <li>Yasal yükümlülüklerin yerine getirilmesi</li>
                </ul>
            </Paragraph>
            <Paragraph>
                <strong>3. İşlenen Kişisel Veriler</strong><br />
                Uygulama aracılığıyla işlenen kişisel veriler şunlardır:
                <ul>
                    <li>Ad, soyad</li>
                    <li>İletişim bilgileri (telefon numarası, e-posta adresi)</li>
                    <li>İş yeri bilgileri</li>
                    <li>Teklif taleplerine ilişkin detaylar</li>
                </ul>
            </Paragraph>
        </Typography>
    ),
};


const ProfileContent: React.FC = () => {
    const [profileData, setProfileData] = useState<ProfileData>({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        address: '',
        identityNumber: '',
        iban: '',
        password: '',
        profilePhoto: '',
        createdAt: '',
        individual: false,
        partner: false,
        isPhoneVerified: false,
    });
    const [form] = Form.useForm();
    const [passwordForm] = Form.useForm();
    const [emailForm] = Form.useForm();
    const [roles, setRoles] = useState<any>();
    const [profileCompletion, setProfileCompletion] = useState(0);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isTermModalVisible, setIsTermModalVisible] = useState(false);
    const [isEmailModalVisible, setIsEmailModalVisible] = useState(false);
    const [isPhoneVerificationModal, setIsPhoneVerificationModal] = useState(false);
    const [emailToUpdate, setEmailToUpdate] = useState('');
    const [activeKey, setActiveKey] = useState('1');
    const [loading, setLoading] = useState(false);
    const [modalContent, setModalContent] = useState(modalContents.clarification);
    const [imageId, setImageId] = useState<string | null>(null);
    const [verificationCode, setVerificationCode] = useState('');
    const [isVerifying, setIsVerifying] = useState(false);
    const [isCustomer, setIsCustomer] = useState(false);

    const [identityPreviewVisible, setIdentityPreviewVisible] = useState(false);
    const [identityPreviewUrl, setIdentityPreviewUrl] = useState<string | null>(null);
    const [identityPreviewIsImage, setIdentityPreviewIsImage] = useState<boolean>(false);

    const notifyProfilePhotoUpdate = (photoId?: string | number | null) => {
        if (photoId === null || photoId === undefined || photoId === '') {
            const hasExistingPhoto = localStorage.getItem('profilePhoto');
            if (hasExistingPhoto !== null) {
                localStorage.removeItem('profilePhoto');
                window.dispatchEvent(new CustomEvent('profilePhotoUpdated', { detail: null }));
            }
            return;
        }

        const profilePhotoIdStr = String(photoId);
        if (localStorage.getItem('profilePhoto') === profilePhotoIdStr) {
            return;
        }

        localStorage.setItem('profilePhoto', profilePhotoIdStr);
        window.dispatchEvent(new CustomEvent('profilePhotoUpdated', { detail: profilePhotoIdStr }));
    };

    const handleOk = () => {
        setIsTermModalVisible(false);
    };

    const handleCancel = () => {
        setIsTermModalVisible(false);
    };

    const resolveRoleList = (override?: any[]) => {
        if (Array.isArray(override)) {
            return override;
        }
        if (Array.isArray(roles)) {
            return roles;
        }
        try {
            const stored = JSON.parse(localStorage.getItem('roles') || '[]');
            return Array.isArray(stored) ? stored : [];
        } catch (error) {
            console.warn('Stored roles parse failed', error);
            return [];
        }
    };

    const shouldUseUserEndpoint = (roleList: any[]): boolean => {
        if (!Array.isArray(roleList)) {
            return false;
        }
        return roleList.some((role: any) => {
            const name = typeof role?.name === 'string' ? role.name : undefined;
            if (!name) {
                return false;
            }
            if (name === 'INSPECTOR' || name === 'ADMIN') {
                return true;
            }
            return name !== 'CUSTOMER';
        });
    };

    const getCustomer = (roleOverride?: any[]) => {
        const roleList = resolveRoleList(roleOverride);
        if (shouldUseUserEndpoint(roleList)) {
            getAccount();
            return;
        }
        UserService.getMe()
            .then((response: any) => {
                setProfileData(response.data);
                setImageId(response.data.profilePhoto);
                localStorage.setItem('firstName', response.data.firstName);
                localStorage.setItem('lastName', response.data.lastName);
                localStorage.setItem('email', response.data.email);
                localStorage.setItem('phoneNumber', response.data.phoneNumber);
                localStorage.setItem('id', response.data.id);
                localStorage.setItem('isPhoneVerified', response.data.isPhoneVerified);
                notifyProfilePhotoUpdate(response.data.profilePhoto);
                localStorage.setItem('isPartner', response.data.isPartner);

                form.setFieldsValue(response.data);
            })
            .catch((error: any) => {
                console.error('Profil verilerini çekerken hata oluştu!', error);
            });
    }


    useEffect(() => {
        const roleList = resolveRoleList();
        const useUserEndpoint = shouldUseUserEndpoint(roleList);

        if (useUserEndpoint && profileData.profilePhoto !== imageId && imageId && !isNaN(imageId as any)) {
            UserService.updateMeUser({ ['profilePhoto']: imageId })
                .then(() => {
                    openNotification('success', 'Başarılı', `Profil resmi başarıyla güncellendi.`);

                    getCustomer(roleList);
                })
                .catch((e: Error) => {
                    console.log(e);
                    openNotification('error', 'Hata', `Profil resmi güncellenirken bir hata oluştu.`);
                });
        }
        if (profileData.profilePhoto !== imageId && imageId && !isNaN(imageId as any)) {
            UserService.updateMe({ ['profilePhoto']: imageId })
                .then(() => {
                    openNotification('success', 'Başarılı', `Profil resmi başarıyla güncellendi.`);

                    getCustomer(roleList);
                })
                .catch((e: Error) => {
                    console.log(e);
                    openNotification('error', 'Hata', `Profil resmi güncellenirken bir hata oluştu.`);
                });
        }
    }, [imageId]);

    const getAccount = () => {
        setLoading(true);
        UserService.getMeUser()
            .then((response: any) => {
                setProfileData(response.data);
                setImageId(response.data.profilePhoto);
                localStorage.setItem('firstName', response.data.firstName);
                localStorage.setItem('lastName', response.data.lastName);
                localStorage.setItem('email', response.data.email);
                localStorage.setItem('phoneNumber', response.data.phoneNumber);
                localStorage.setItem('isPhoneVerified', response.data.isPhoneVerified);
                localStorage.setItem('id', response.data.id);
                notifyProfilePhotoUpdate(response.data.profilePhoto);
                form.setFieldsValue(response.data);
            })
            .finally(() => {
                setLoading(false);
            })
            .catch((error: any) => {
                console.error('Profil verilerini çekerken hata oluştu!', error);
            });
    }

    useEffect(() => {

        const isRoleCustomer = hasRole('CUSTOMER');
        setIsCustomer(isRoleCustomer);

        let role = JSON.parse(localStorage.getItem('roles') || '[]')
        setRoles(role);
        if (role && role.some((role: any) => role.name === 'ADMIN')) {
            getAccount();
        } else {
            getCustomer(role)
        }
    }, [])


    const handlePasswordChange = (values: any) => {
        const { currentPassword, newPassword } = values;
        UserService.updatePassword({ currentPassword, newPassword })
            .then((response: any) => {
                openNotification('success', 'Başarılı', 'Şifreniz başarıyla değiştirildi.');
                setIsModalVisible(false);
                passwordForm.resetFields(); // Formu temizle
            })
            .catch((error: any) => {
                console.error('Şifre değiştirme işlemi sırasında hata oluştu!', error);
                openNotification('error', 'Hata', 'Şifre değiştirme işlemi sırasında bir hata oluştu. Eski şifrenizi doğru girdiğinizden emin olun.');
            });
    };

    const handleEmailChange = (values: any) => {
        const { password, email } = values;
        UserService.updateEmailRequest({ password, email })
            .then((response: any) => {
                openNotification('success', 'Başarılı', 'Email değiştirme isteği gönderildi.');
                setIsEmailModalVisible(false);
                emailForm.resetFields();
            })
            .catch((error: any) => {
                console.error('Email değiştirme işlemi sırasında hata oluştu!', error.response.data.errorCode);
                if (error.response.data.errorCode == 'account-already-exists') {
                    openNotification('error', 'Hata', 'Değiştirmek istediğiniz E-posta adresi sistemde kayıtlı.');
                } else {
                    openNotification('error', 'Hata', 'E-posta değiştirme işlemi sırasında bir hata oluştu. Yeni e-posta adresinizi ve şifrenizi doğru girdiğinizden emin olun. ');
                }
            });
    };

    const handleEmailUpdateClick = () => {
        // INSPECTOR rolü için e-posta değişimi engellenir
        const roleList = roles || JSON.parse(localStorage.getItem('roles') || '[]');
        const isInspector = Array.isArray(roleList) && roleList.some((r: any) => r?.name === 'INSPECTOR');
        if (isInspector) {
            openNotification('error', 'Yetki Hatası', 'INSPECTOR rolünde e-posta değiştirilemez.');
            return;
        }
        setEmailToUpdate(profileData.email);
        setIsEmailModalVisible(true);
    };

    const handleVerifyCode = () => {
        const normalizedCode = String(verificationCode ?? '').replace(/\D/g, '');
        if (normalizedCode.length !== 6) {
            openNotification('error', 'Hata', '6 haneli geçerli bir kod giriniz.');
            return;
        }

        setIsVerifying(true);

        UserService.verificationPhone(normalizedCode)
            .then(() => {
                openNotification('success', 'Başarılı', 'Telefon numaranız başarıyla doğrulandı.');
                setIsPhoneVerificationModal(false);
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            })
            .catch((e: Error) => {
                console.error(e);
                openNotification('error', 'Hata', 'Doğrulama sırasında bir hata oluştu.');
            })
            .finally(() => setIsVerifying(false));
    };


    const handlePhoneValidation = () => {
        UserService.sendVerificationPhone()
            .then(() => {
                openNotification('success', 'Başarılı', `Telefonunuza onay mesajı gönderildi`);
                setIsPhoneVerificationModal(true);
            })
            .catch((e: Error) => {
                // Hata oluşursa
                console.log(e);
                openNotification('error', 'Hata', `Telefona onay mesajı gönderilirken hata oluştu.`);
            });
    };

    const calculateProfileCompletion = () => {
        // 1) Admin mi? Değil mi?
        const isAdmin = roles?.some((role: any) => role.name === 'ADMIN');

        // 2) Zorunlu alanlar
        let fieldsWeCareAbout = [
            'firstName',
            'lastName',
            'email',
            'phoneNumber',
            'iban',
            'address',
            'identityNumber',
        ];

        // Admin ise identityNumber'ı (TC Kimlik No) hariç tutuyoruz
        if (isAdmin) {
            fieldsWeCareAbout = [
                'firstName',
                'lastName',
                'email',
                'phoneNumber',
                'iban',
                'address',
            ];
        }

        // 3) Dolu alanların sayısını hesapla
        const totalFields = fieldsWeCareAbout.length;
        let filledFields = 0;
        fieldsWeCareAbout.forEach((field) => {
            if (profileData[field]) {
                filledFields++;
            }
        });

        // 4) Oran (% cinsinden)
        const percentage = (filledFields / totalFields) * 100;
        setProfileCompletion(percentage);
    };

    const handleTabChange = (key: string) => {
        setActiveKey(key);
    };


    function validateIBAN(iban: string): boolean {
        iban = iban.replace(/\s+/g, '').toUpperCase();

        // IBAN TR ile başlamalı ve toplam 26 karakter olmalı
        if (!iban.startsWith('TR') || iban.length !== 26) {
            return false;
        }

        // TR dışındaki karakterler sayı olmalı
        const ibanDigits = iban.slice(2);
        if (!/^\d+$/.test(ibanDigits)) {
            return false;
        }

        return true;
    }


    const handleUpdateProfile = (values: any) => {
        const roleList = resolveRoleList();
        const useUserEndpoint = shouldUseUserEndpoint(roleList);
        if (useUserEndpoint) {
            UserService.updateMeUser(values)
                .then((response: any) => {
                    openNotification('success', 'Başarılı', 'Profiliniz başarıyla güncellendi.');
                    getCustomer(roleList)
                })
                .catch((e: Error) => {
                    console.log(e);
                });

        } else {
            UserService.updateMe(values)
                .then((response: any) => {
                    openNotification('success', 'Başarılı', 'Profiliniz başarıyla güncellendi.');
                    getCustomer(roleList)
                })
                .catch((e: any) => {
                    openNotification('error', 'Hata', e.response.data);
                });
        }
    };

    // Türkçe karakter desteği ile büyük harfe dönüştürme fonksiyonu
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
        const input = e.target;
        const start = input.selectionStart;
        const end = input.selectionEnd;
        const upperValue = input.value.toLocaleUpperCase('tr-TR');

        form.setFieldsValue({ [fieldName]: upperValue });

        // İmleç pozisyonunu koruma
        setTimeout(() => {
            input.setSelectionRange(start, end);
        }, 0);
    };

    useEffect(() => {
        form.setFieldsValue(profileData);
        calculateProfileCompletion();
    }, [profileData])

    const handleUpdatePhone = (value: any) => {
        const roleList = resolveRoleList();
        const useUserEndpoint = shouldUseUserEndpoint(roleList);
        if (useUserEndpoint) {
            UserService.updateMeUser({ ['phoneNumber']: value })
                .then(() => {
                    openNotification('success', 'Başarılı', `Telefon başarıyla güncellendi.`);
                    getCustomer(roleList);
                })
                .catch((e: Error) => {
                    // Hata oluşursa
                    console.log(e);
                    openNotification('error', 'Hata', `Telefon güncellenirken bir hata oluştu.`);
                });

        } else {
            UserService.updateMe({ ['phoneNumber']: value })
                .then(() => {
                    openNotification('success', 'Başarılı', `Telefon başarıyla güncellendi.`);
                    getCustomer(roleList);
                })
                .catch((e: Error) => {
                    // Hata oluşursa
                    console.log(e);
                    openNotification('error', 'Hata', `Telefon güncellenirken bir hata oluştu.`);
                });
        }
    };

    const handleUpdateIndividual = (value: any) => {
        const roleList = resolveRoleList();
        const useUserEndpoint = shouldUseUserEndpoint(roleList);
        const refresh = () => getCustomer(roleList);
        UserService.updateMe({ ['isIndividual']: value })
            .then(() => {
                openNotification('success', 'Başarılı', `Şirket bilginiz başarıyla güncellendi.`);
                if (useUserEndpoint) {
                    getAccount();
                } else {
                    refresh();
                }
            })
            .catch((e: Error) => {
                // Hata oluşursa
                console.log(e);
                openNotification('error', 'Hata', `Şirket bilginiz bir hata oluştu.`);
            });
    };

    return (
        <div className='profile-section'>
            <Row gutter={[16, 16]} justify="center">
                <Col xs={24}>
                    <Card bordered={false} className='profile-card' loading={loading}>
                        <Row align="middle" justify="space-between">
                            <Col>
                                <Row gutter={[16, 16]}>
                                    <Col>
                                        {/* // Upload component */}
                                        <ImageUpload imageId={profileData.profilePhoto} setImageId={setImageId} type={'profile'} />
                                    </Col>
                                    <Col>
                                        <div>
                                            <Title level={4} style={{ margin: 0 }}>{profileData.firstName + ' ' + profileData.lastName}</Title>
                                            <Text style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                                                <Mail02Icon style={{ width: 18, height: 18, marginRight: 5 }} />
                                                <span>{profileData.email}</span>
                                                {/* INSPECTOR rolü e-posta değiştiremez */}
                                                {!(roles && roles.some((role: any) => role.name === 'INSPECTOR')) && (
                                                    <Button style={{ paddingLeft: 5, color: "black" }} type="link" onClick={handleEmailUpdateClick}>Değiştir</Button>
                                                )}
                                            </Text>
                                            <Text style={{ display: "flex", justifyContent: "start", alignItems: "center", gap: 4 }}>
                                                <SmartPhone01Icon style={{ width: 18, height: 18, marginRight: 5 }} />
                                                {(profileData?.phoneNumber && profileData?.phoneNumber !== null && profileData?.phoneNumber !== "") && (
                                                    <PhoneNumberDisplay value={profileData?.phoneNumber} />
                                                )}
                                                {(profileData?.phoneNumber === null || profileData?.phoneNumber === "") && <Text type="danger" style={{ fontWeight: 600 }}> Telefon eksik</Text>}
                                                {(!profileData?.isPhoneVerified && profileData?.phoneNumber !== null && profileData?.phoneNumber !== "" && profileData.phoneNumber) && <Text type="danger" style={{ fontWeight: 600, marginLeft: 5, cursor: "pointer" }} onClick={handlePhoneValidation}>Doğrula</Text>}
                                                {(profileData?.isPhoneVerified && profileData?.phoneNumber !== null && profileData?.phoneNumber !== "" && profileData.phoneNumber) && <Text type="success" style={{ fontWeight: 600, marginLeft: 5 }}>Doğrulandı</Text>}
                                            </Text>
                                            {roles && !roles.some((role: any) => role.name === 'CUSTOMER') && (
                                                <>
                                                    <Text>Kayıt Tarihi: {formatDateString(profileData.createdAt)}</Text><br />
                                                </>
                                            )}
                                            <Row >
                                                <Progress percent={profileCompletion} showInfo={false} size="small" trailColor='primary' style={{ flex: 1 }} strokeColor={'#6179fa'} />
                                                <Text style={{ marginLeft: '10px' }}> %{Math.round(profileCompletion)}</Text>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col>
                                <Button className='' type="primary" onClick={() => setIsModalVisible(true)}>Şifre Değiştir</Button>
                            </Col>
                        </Row>
                    </Card>
                    <Card className='profile-card' style={{ marginTop: 32 }}>
                        <Tabs activeKey={activeKey} onChange={handleTabChange} className="custom-tabs"
                            tabBarStyle={{ borderBottom: 'none' }} destroyInactiveTabPane>
                            <TabPane
                                tab={
                                    <Button type={activeKey === '1' ? 'primary' : 'default'} className='d-button tab-button'>Kullanıcı Bilgileri</Button>
                                }
                                key="1"
                            >
                                {!profileData.email ? ' ' :
                                    <Form form={form} layout="vertical" onFinish={handleUpdateProfile}>
                                        <Row gutter={24}>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    label="Ad"
                                                    name="firstName"
                                                    rules={[{ required: true, message: 'Ad gerekli' }]}
                                                >
                                                    <Input
                                                        className='d-input d-input-form'
                                                        placeholder="Ad girin"
                                                        onChange={(e) => handleInputChange(e, 'firstName')}
                                                        onKeyPress={(event) => {
                                                            const key = event.key;
                                                            const target = event.target as HTMLInputElement;
                                                            const isValid = /[a-zA-ZığüşöçİĞÜŞÖÇ\s]/.test(key);
                                                            const errorMsg = document.getElementById('firstName-error');

                                                            if (!isValid) {
                                                                event.preventDefault();
                                                                if (!errorMsg) {
                                                                    const errorDiv = document.createElement('div');
                                                                    errorDiv.id = 'firstName-error';
                                                                    errorDiv.style.color = 'red';
                                                                    errorDiv.innerText = 'Sadece harf kullanabilirsiniz.';
                                                                    target.parentNode?.appendChild(errorDiv);
                                                                }
                                                            } else if (errorMsg) {
                                                                errorMsg.remove();
                                                            }

                                                            if (target.value.length >= 100) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    label="Soyad"
                                                    name="lastName"
                                                    rules={[{ required: true, message: 'Soyad gerekli' }]}
                                                >
                                                    <Input
                                                        className='d-input d-input-form'
                                                        placeholder="Soyad girin"
                                                        onChange={(e) => handleInputChange(e, 'lastName')}
                                                        onKeyPress={(event) => {
                                                            const key = event.key;
                                                            const target = event.target as HTMLInputElement;
                                                            const isValid = /[a-zA-ZığüşöçİĞÜŞÖÇ\s]/.test(key);
                                                            const errorMsg = document.getElementById('lastName-error');

                                                            if (!isValid) {
                                                                event.preventDefault();
                                                                if (!errorMsg) {
                                                                    const errorDiv = document.createElement('div');
                                                                    errorDiv.id = 'lastName-error';
                                                                    errorDiv.style.color = 'red';
                                                                    errorDiv.innerText = 'Sadece harf kullanabilirsiniz.';
                                                                    target.parentNode?.appendChild(errorDiv);
                                                                }
                                                            } else if (errorMsg) {
                                                                errorMsg.remove();
                                                            }

                                                            if (target.value.length >= 100) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={12}>
                                                <Form.Item
                                                    name="phoneNumber"
                                                    label="Telefon"
                                                    labelCol={{ span: 24 }}
                                                    wrapperCol={{ span: 24 }}
                                                    rules={[
                                                        { required: true, message: 'Telefon gerekli' },
                                                        {
                                                            validator: (_, value) => {
                                                                if (!value) return Promise.resolve(); // Boş olabilir
                                                                if (!/^[5][0-9]{9}$/.test(value)) {
                                                                    return Promise.reject(new Error('Telefon 5 ile başlamalı ve 10 rakamdan oluşmalıdır.'));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        },
                                                    ]}
                                                >
                                                    <Input
                                                        className="d-input"
                                                        placeholder="Telefon"
                                                        addonBefore="+90"
                                                        defaultValue={profileData?.phoneNumber}
                                                        maxLength={10}
                                                        onPaste={(e) => handlePhonePaste(e, { form, fieldName: 'phoneNumber' })}
                                                        onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                    />

                                                </Form.Item>
                                            </Col>

                                            {isCustomer && (<>

                                                <Col xs={24} md={12}>
                                                    <Form.Item
                                                        label="IBAN"
                                                        name="iban"
                                                        rules={[
                                                            { required: true, message: 'IBAN gerekli' },
                                                            {
                                                                validator: (_, value) => {
                                                                    if (!value) return Promise.resolve();
                                                                    const isValid = validateIBAN('TR' + value); // Doğru IBAN kontrolü
                                                                    if (!isValid) {
                                                                        return Promise.reject(new Error('Geçersiz IBAN'));
                                                                    }
                                                                    return Promise.resolve();
                                                                },
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            addonBefore="TR"
                                                            placeholder="0011 1000 0011 1000 0011 01"
                                                            className="d-input d-input-form fs-24px"
                                                            // maxLength kaldırıldı veya 26 yapılabilir (addonBefore dahil)
                                                            defaultValue={profileData.iban || ''}
                                                            onChange={(event) => {
                                                                const rawValue = event.target.value;

                                                                // Tüm boşlukları ve harfleri temizle, sadece rakamları al
                                                                const onlyNumbers = rawValue.replace(/[^0-9]/g, '');

                                                                // Max 24 rakam (TR harici)
                                                                const sanitized = onlyNumbers.slice(0, 24);

                                                                form.setFieldsValue({ iban: sanitized });
                                                            }}
                                                            onKeyPress={(event) => {
                                                                if (!/[0-9]/.test(event.key)) {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item
                                                        label="TC Kimlik No"
                                                        name="identityNumber"
                                                        rules={[
                                                            { required: true, message: 'Lütfen TC Kimlik No giriniz!' },
                                                            { pattern: /^[0-9]*$/, message: 'TC Kimlik No sadece rakamlardan oluşmalıdır' },
                                                            {
                                                                validator: (_, value) => {
                                                                    if (!value || value.length !== 11) {
                                                                        return Promise.reject('TC Kimlik Numarası 11 haneli olmalıdır');
                                                                    }

                                                                    const firstTenDigits = value.substring(0, 10).split('').map(Number);
                                                                    const sumOfFirstTen = firstTenDigits.reduce((acc: any, curr: any) => acc + curr, 0);
                                                                    const lastDigitOfSum = sumOfFirstTen % 10;

                                                                    if (lastDigitOfSum !== Number(value[10])) {
                                                                        return Promise.reject('TC Kimlik Numarası geçersiz.');
                                                                    }

                                                                    return Promise.resolve();
                                                                },
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            placeholder="12345678901"
                                                            className="d-input d-input-form"
                                                            defaultValue={isNaN(Number(profileData.identityNumber)) ? '' : profileData.identityNumber}
                                                            maxLength={11}
                                                            onKeyPress={(event) => {
                                                                if (!/[0-9]/.test(event.key)) {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item name="isIndividual" valuePropName="checked">
                                                        <Checkbox
                                                            defaultChecked={profileData.individual}
                                                            onChange={(e) => {
                                                                handleUpdateIndividual(e.target.checked);
                                                                form.setFieldsValue({ individual: e.target.checked });
                                                            }}
                                                        >
                                                            Şahıs Şirketiniz var ise lütfen işaretleyiniz.
                                                        </Checkbox>
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item
                                                        label="Adres"
                                                        name="address"
                                                        rules={[
                                                            { required: true, message: 'Adres gerekli' },
                                                            { max: 500, message: 'Adres en fazla 500 karakter olmalıdır' },
                                                        ]}
                                                    >
                                                        <Input.TextArea
                                                            rows={4}
                                                            className="d-input d-input-form"
                                                            placeholder="Adres girin"
                                                            onKeyPress={(event) => {
                                                                const target = event.target as HTMLTextAreaElement;
                                                                if (target.value.length >= 500) {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                    </Form.Item>
                                                </Col></>)}
                                            {/* <Col xs={24} md={12}>
                                                <Form.Item
                                                    label="E-posta"
                                                    name="email"
                                                    rules={[
                                                        { required: true, message: 'E-posta gerekli' },
                                                        { type: 'email', message: 'Geçerli bir e-posta girin' },
                                                    ]}
                                                >
                                                    <Space.Compact className="width-100">
                                                        <Input
                                                            className='d-input d-input-form'
                                                            placeholder="E-posta girin"
                                                            defaultValue={profileData.email}
                                                        />
                                                        <Button className='d-button-with-input width-auto' type='primary' onClick={handleEmailUpdateClick}>Değiştir</Button>
                                                    </Space.Compact>
                                                </Form.Item>
                                            </Col> */}

                                            {/* <Col xs={24} md={12}>
                                                <Form.Item
                                                    label="Şifre"
                                                    name="password"
                                                    rules={[
                                                        { required: false, message: 'Şifre gerekli' },
                                                        { min: 8, message: 'Şifre en az 8 karakter olmalıdır' }
                                                    ]}
                                                >
                                                    <Space.Compact className="width-100">
                                                        <Input
                                                            placeholder="Şifre"
                                                            className='d-input d-input-form'
                                                            defaultValue={'*********'}
                                                            disabled
                                                        />
                                                        <Button className='d-button-with-input width-auto' type="primary" onClick={() => setIsModalVisible(true)}>Değiştir</Button>
                                                    </Space.Compact>
                                                </Form.Item>
                                            </Col> */}

                                        </Row>
                                        <Form.Item>
                                            <Row justify={'end'}>
                                                <Button className='d-button dark-button width-auto' type="primary" htmlType="submit">
                                                    Kaydet
                                                </Button>
                                            </Row>
                                        </Form.Item>
                                    </Form>
                                }
                            </TabPane>
                            {(isCustomer && <TabPane
                                tab={
                                    <Button type={activeKey === '2' ? 'primary' : 'default'} className='d-button tab-button'>Sözleşme</Button>
                                } key="2">
                                <Contracts profileCompletion={profileCompletion} partner={profileData.isPartner} profileData={profileData} />
                            </TabPane>)}

                            {isCustomer && (
                                <TabPane
                                    tab={
                                        <Button type={activeKey === '4' ? 'primary' : 'default'} className='d-button tab-button'>Belgeler</Button>
                                    }
                                    key="4"
                                >
                                    <DocumentsTab profileData={profileData} setProfileData={setProfileData} />
                                </TabPane>
                            )}

                            <TabPane
                                tab={
                                    <Button type={activeKey === '3' ? 'primary' : 'default'} className='d-button tab-button'>Hesap Aktivitileri</Button>
                                } key="3">
                                <UserAttemps />
                            </TabPane>




                        </Tabs>
                    </Card>
                </Col>
            </Row>

            <Modal
                title="Şifre değiştir"
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                width={450}
                style={{ borderRadius: '10px' }}
            >
                <Form form={passwordForm} onFinish={handlePasswordChange} layout="vertical">
                    <Form.Item
                        label="Mevcut Şifre"
                        name="currentPassword"
                        rules={[{ required: true, message: 'Şifre boş bırakılamaz' }]}
                    >
                        <Input.Password className='d-input d-input-form' />
                    </Form.Item>
                    <Form.Item
                        label="Yeni Şifre"
                        name="newPassword"
                        rules={[
                            { required: true, message: 'Yeni şifre boş bırakılamaz' },
                            {
                                validator: (_, value) => {
                                    const errors = [];
                                    if (!value) {
                                        return Promise.reject(new Error('Şifre boş bırakılamaz!'));
                                    }
                                    if (value.length < 8) {
                                        errors.push('Şifre en az 8 karakter olmalıdır!');
                                    }
                                    // if (!/[A-Z]/.test(value)) {
                                    //     errors.push('En az bir büyük harf içermelidir!');
                                    // }
                                    // if (!/[a-z]/.test(value)) {
                                    //     errors.push('En az bir küçük harf içermelidir!');
                                    // }
                                    if (!/[0-9]/.test(value)) {
                                        errors.push('En az bir sayı içermelidir!');
                                    }
                                    if (errors.length > 0) {
                                        return Promise.reject(new Error(errors.join('\n')));
                                    }
                                    return Promise.resolve();
                                },
                            },
                        ]}
                    >
                        <Input.Password className='d-input d-input-form' />
                    </Form.Item>
                    <Form.Item
                        label="Yeni Şifre Tekrarı"
                        name="confirmPassword"
                        dependencies={['newPassword']}
                        rules={[
                            { required: true, message: 'Yeni şifre (tekrar) boş bırakılamaz' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('newPassword') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Şifreler uyuşmuyor.'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password className='d-input d-input-form' />
                    </Form.Item>
                    <Form.Item>
                        <Row justify={'center'}>
                            <Button className='d-button dark-button width-auto' type="primary" htmlType="submit" block>Değiştir</Button>
                        </Row>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title="Türkiye Cumhuriyeti Kimlik Kartı"
                open={identityPreviewVisible}
                onCancel={() => setIdentityPreviewVisible(false)}
                footer={null}
                width={900}
                bodyStyle={{ padding: 0 }}
            >
                {identityPreviewUrl && (
                    identityPreviewIsImage ? (
                        <div style={{ textAlign: 'center', padding: 16 }}>
                            <img src={identityPreviewUrl} alt="Türkiye Cumhuriyeti Kimlik Kartı" style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }} />
                        </div>
                    ) : (
                        <iframe
                            src={identityPreviewUrl}
                            title="Türkiye Cumhuriyeti Kimlik Kartı"
                            style={{ width: '100%', height: '80vh', border: 'none' }}
                        />
                    )
                )}
            </Modal>

            <Modal
                title="E-posta değiştir"
                visible={isEmailModalVisible}
                onCancel={() => setIsEmailModalVisible(false)}
                footer={null}
                width={400}
                style={{ borderRadius: '10px' }}
            >
                <Form form={emailForm} onFinish={handleEmailChange} layout="vertical">
                    <Form.Item
                        label="Yeni E-Posta"
                        name="email"
                        rules={[{ required: true, message: 'E-Posta boş bırakılamaz', type: 'email' }]}
                    >
                        <Input defaultValue={""} className='d-input d-input-form' />
                    </Form.Item>

                    <Form.Item
                        label="Mevcut Şifre"
                        name="password"

                        rules={[{ required: true, message: 'Şifre boş bırakılamaz' }]}
                    >
                        <Input.Password className='d-input d-input-form' />
                    </Form.Item>
                    <Form.Item>
                        <Row justify={'center'}>
                            <Button className='d-button dark-button width-auto' type="primary" htmlType="submit" block>Değiştir</Button>
                        </Row>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal title="Bilgilendirme" visible={isTermModalVisible} onOk={handleOk} onCancel={handleCancel} footer={null} centered bodyStyle={{ maxHeight: '500px', overflowY: 'auto' }}>
                {modalContent}
            </Modal>
            <Modal
                title="Telefon Doğrulama"
                visible={isPhoneVerificationModal}
                onCancel={() => setIsPhoneVerificationModal(false)}
                footer={[
                    <Button key="cancel" onClick={() => setIsPhoneVerificationModal(false)}>
                        İptal
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        loading={isVerifying}
                        onClick={handleVerifyCode}
                    >
                        Onayla
                    </Button>,
                ]}
            >
                <p>Lütfen SMS ile gelen 6 haneli doğrulama kodunu giriniz:</p>
                <Row justify="center">
                    <Input.OTP
                        formatter={(str) => str.replace(/\D/g, '')}
                        onChange={(val) => setVerificationCode(val)}
                    />
                </Row>
            </Modal>
        </div>
    );
};

export default ProfileContent;
